import { AxiosResponse } from 'axios'
import { Moment } from 'moment'

import ClientSDK from '../../../App/ClientSDK'
import { IActivityCategory, IApiActivityCategory } from '../interface/IActivity'
import {
  ICreateWaitingCustomer,
  ICreateWaitingCustomerResponse,
} from '../interface/ICreateWaitingCustomer'
import { IApiMenuCategory, IMenuCategory } from '../interface/IMenuCategory'
import {
  IApiWaitingCustomer,
  IWaitingCustomer,
} from '../interface/IWaitingCustomer'

import Transformer from './Transformer'

export default class Client {
  static getWaitingCustomers(
    startDate: Moment | undefined,
    endDate: Moment | undefined,
  ): Promise<any> {
    const url =
      startDate !== undefined && endDate !== undefined
        ? 'waiting-list' +
          `/${startDate.format('YYYY-MM-DD')}/${endDate.format('YYYY-MM-DD')}`
        : 'waiting-list'
    return ClientSDK.instance()
      .get(url)
      .then((response: AxiosResponse<IApiWaitingCustomer[]>) => {
        return response.data.map((apiWaitingCustomer: IApiWaitingCustomer) =>
          Transformer.transform(apiWaitingCustomer),
        )
      })
  }

  static deleteWaitingCustomer(customersQueueId: string): Promise<any> {
    return ClientSDK.instance()
      .delete(`waiting-list/${customersQueueId}/delete`)
      .then((response: AxiosResponse) => response)
  }

  static undoDeleteWaitingCustomer(customersQueueId: string): Promise<any> {
    return ClientSDK.instance()
      .delete(`waiting-list/${customersQueueId}/undo-delete`)
      .then((response: AxiosResponse) => response)
  }

  static createWaitingCustomer(
    waitingCustomer: ICreateWaitingCustomer,
  ): Promise<ICreateWaitingCustomerResponse> {
    return ClientSDK.instance()
      .post(`waiting-list/create`, waitingCustomer)
      .then((response: AxiosResponse) => {
        return { ...waitingCustomer, id: response.data.id }
      })
  }

  static updateWaitingCustomers(waitingCustomers: IWaitingCustomer[]) {
    return ClientSDK.instance()
      .patch(`waiting-list/update`, {
        waiting_customer: waitingCustomers,
      })
      .then((response: AxiosResponse<IApiWaitingCustomer[]>) => {
        return response.data.map((apiWaitingCustomer: IApiWaitingCustomer) =>
          Transformer.transform(apiWaitingCustomer),
        )
      })
  }
  public static getActivitySelect(
    establishmentId: string,
  ): Promise<IActivityCategory[]> {
    return ClientSDK.instance()
      .get(
        `anonymous/calendar/activity-tree?establishment_id=${establishmentId}`,
      )
      .then((response: AxiosResponse<IApiActivityCategory[]>) => {
        return response.data.map((category: IApiActivityCategory) =>
          Transformer.transformCategories(category),
        )
      })
  }
  public static getMenuCategories(
    establishmentId: string,
  ): Promise<IMenuCategory[]> {
    return ClientSDK.instance()
      .get(`anonymous/activity-menu?establishment_id=${establishmentId}`)
      .then((response: AxiosResponse<IApiMenuCategory[]>) =>
        Transformer.transformMenu(response.data),
      )
  }
}
